<script setup lang="ts">
import { computed } from 'vue'
import Icon from '@/components/Base/BaseIcon.vue'
import type { IconName } from '@/components/Base/Icons/icons'

const props = withDefaults(
  defineProps<{
    iconName?: IconName
    iconSize?: string
    iconRotationDegree?: number
    classes?: string[]
    size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl'
    disabled?: boolean
  }>(),
  {
    size: 'base',
    classes: () => [],
  }
)

const iconSizeClasses = computed(() => {
  return props.size === 'xl' ? 'text-md' : 'text-sm'
})

const paddingClasses = computed(() => {
  switch (props.size) {
    case 'xs':
      return 'w-[30px] h-[30px] p-[5px]'

    case 'sm':
      return 'w-[34px] h-[34px] p-[7px]'

    case 'base':
      return 'w-[38px] h-[38px] p-[9px]'

    case 'lg':
      return 'w-[42px] h-[42px] p-[9px]'

    case 'xl':
      return 'w-[50px] h-[50px] p-[13px]'
  }
})
</script>

<template>
  <button
    class="app-button rounded-full"
    type="button"
    :class="[
      ...classes,
      paddingClasses,
      iconSizeClasses,
      { 'app-button--disabled': disabled },
    ]"
    :disabled="disabled"
  >
    <Icon
      :name="iconName as IconName"
      :size="iconSize"
      :rotation-degree="iconRotationDegree"
    />
    <slot />
  </button>
</template>
